module.exports = __webpack_public_path__ + "static/mrc_chart4.ed21e829.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mrc_chart4.png
// module id = 1369
// module chunks = 14018417377433 170120657441983